import { defineStore } from 'pinia';
import { useGlobalStore } from './global.js';
import { useFlashMessagesStore } from './flashMessages.js';
import {
  request,
  getApiUrl,
} from '../helpers/mainHelpers.js';

export const useAutocompleteStore = defineStore('autocomplete', {
  state: () => ({
    autocompleteProductList: [],
    isDisplayableProductsApiError: false,
  }),
  getters: {
    getAutocompleteProductList: (state) => {
      const globalStore = useGlobalStore();
      const queryParams = globalStore.router?.currentRoute?.value?.query || {};

      // Normalize compareProducts params
      let compareProducts;

      if (Array.isArray(queryParams.compareProduct)) {
        compareProducts = queryParams.compareProduct;
      } else if (queryParams.compareProduct) {
        compareProducts = [queryParams.compareProduct];
      } else {
        compareProducts = [];
      }

      // Filter out products already selected to prevent duplicates in Autocomplete
      return state.autocompleteProductList.filter((item) => !compareProducts.includes(item.value?.productId));
    },
    getIsDisplayableProductsApiError: (state) => state.isDisplayableProductsApiError,
    getProductAutocompleteText: () => {
      const globalStore = useGlobalStore();
      return globalStore.translations?.ITFE_PRODUCT_COMPARE_SEARCH_FOR_PRODUCTS;
    },
    getIsAutocompleteDisabled: (state) => state.isDisplayableProductsApiError,
  },
  actions: {
    setAutocompleteProductList(list) {
      const formattedList = [];

      if (Array.isArray(list)) {
        list.forEach((item) => {
          const partNumber = item?.partNumber || false;
          const shouldAddItemToList = item?.productName && item?.productId;

          if (shouldAddItemToList) {
            formattedList.push({
              label: item?.productName,
              value: {
                productId: item?.productId,
                partNumber,
              },
            });
          }
        });
      }
      this.autocompleteProductList = formattedList;
    },
    setIsDisplayableProductsApiError(value) {
      this.isDisplayableProductsApiError = value;
    },
    async loadAutocompleteProductList() {
      // Return early if list is already populated
      if (this.autocompleteProductList?.length) return;

      const globalStore = useGlobalStore();

      try {
        const response = await request({
          method: 'GET',
          url: `${getApiUrl()}/getDisplayableProducts?locale=${globalStore.locale}`,
        });

        this.setAutocompleteProductList(response);
      } catch (err) {
        this.isDisplayableProductsApiError = true;

        const flashMessagesStore = useFlashMessagesStore();

        // Set custom banner error message
        flashMessagesStore.setFlashMessage({
          type: 'error',
          text: globalStore.getTranslations?.ITFE_PRODUCT_COMPARE_PRODUCT_SEARCH_SERVICE_API_ERROR_MESSAGE,
          closeable: false,
          testId: 'product-search-unavailable',
          align: 'center',
        });

        throw err;
      }
    },
  },
});
